import { groupTitle } from '../../utils/fieldclimateGroups';

// Map markers for the FieldClimate weather station: two icons, one per data group
// (see utils/fieldclimateGroups). Clicking an icon opens that group's tables and charts.

// Kargıcak and Kestel stations; other stations keep the plain sensor marker.
const WEATHER_CARD_STATIONS = new Set(['050175F6', '05017605']);

export const isWeatherCardStation = (sensor) =>
    !!sensor?.fieldclimateStationId && WEATHER_CARD_STATIONS.has(sensor.fieldclimateStationId);

// List rows for a sensor: a weather-card station appears as its two group views (each opens
// its own detail screen); any other sensor keeps a single row.
export function sensorEntries(sensor, lang) {
    if (!isWeatherCardStation(sensor)) return [{ key: String(sensor.id), label: sensor.name, sensor }];
    const station = (sensor.name || '').replace(/^Meteo - FieldClimate\s*/i, '');
    return ['weather', 'agro'].map(group => ({
        key: `${sensor.id}-${group}`,
        label: `${station} · ${groupTitle(group, lang)}`,
        sensor: { ...sensor, fcGroup: group },
    }));
}

const STYLE = {
    // thermometer + cloud
    weather: {
        bg: '#0e7490',
        glyph: '<path d="M10 13.5V5a2 2 0 1 0-4 0v8.5a3.5 3.5 0 1 0 4 0z"/><path d="M14 10h4.5a3 3 0 0 1 0 6H14"/><path d="M15.5 10a2.5 2.5 0 0 1 4.6-1.3"/>',
    },
    // wind + rising drop (ET0)
    agro: {
        bg: '#4d7c0f',
        glyph: '<path d="M3 9h9a2.5 2.5 0 1 0-2.5-2.5"/><path d="M3 13h13a2.5 2.5 0 1 1-2.5 2.5"/><path d="M19 4.5c1.2 1.6 2 2.7 2 3.6a2 2 0 0 1-4 0c0-.9.8-2 2-3.6z"/>',
    },
};

const GAP = 3;

export function groupMarker(group, isSelected) {
    const { bg, glyph } = STYLE[group];
    const size = isSelected ? 32 : 26;
    const ring = isSelected
        ? `box-shadow:0 0 0 3px #fff,0 0 0 5px ${bg},0 4px 12px rgba(0,0,0,0.45);`
        : 'box-shadow:0 2px 8px rgba(0,0,0,0.45);';
    const glyphSize = Math.round(size * 0.66);
    return {
        size,
        // weather sits left of the coordinate, agro right of it
        iconAnchor: group === 'weather' ? [size + GAP, size / 2] : [-GAP, size / 2],
        html: `<div style="width:${size}px;height:${size}px;border-radius:8px;background:${bg};border:2px solid #fff;${ring}display:flex;align-items:center;justify-content:center;cursor:pointer;">
            <svg viewBox="0 0 24 24" width="${glyphSize}" height="${glyphSize}" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${glyph}</svg>
        </div>`,
    };
}
